import groq from 'groq'

import { frameBuilderPortableTextFragment } from './content'

const frameBuilderArtworkSizeStringsFragment = groq`
  artworkSizeStepTitle,
  artworkSizePlaceholder,
  artworkSizeSizeNotValid,
  artworkSizeStandardSizeLabel,
  artworkSizeCustomOptionLabel,
  artworkSizeWidthLabel,
  artworkSizeHeightLabel,
  artworkSizeWidthAndHeightDescription[] {
    ${frameBuilderPortableTextFragment}
  },
  artworkSizeNoSelection,
  artworkSizeNoWidthSelected,
  artworkSizeNoHeightSelected,
  artworkSizeOutOfProfileLimits,
  artworkSizeSizeSuffix,
  artworkSizeStandardSizeMessage,
  artworkSizeStandardSizeLinkText,
  artworkSizeStepFooter[] {
    ${frameBuilderPortableTextFragment}
  },
`

const frameBuilderArtworkPreviewStringsFragment = groq`
  artworkPreviewStepTitle,
  artworkPreviewPlaceholder,
  artworkPreviewArtworkLabel,
  artworkPreviewArtworkDescription[] {
    ${frameBuilderPortableTextFragment}
  },
  artworkPreviewBackgroundColorLabel,
  artworkPreviewBackgroundColorPlaceholder,
  artworkPreviewNoSelection,
  artworkPreviewStepFooter[] {
    ${frameBuilderPortableTextFragment}
  },
`

const frameBuilderFrameStyleStringsFragment = groq`
  frameStyleStepTitle,
  frameStylePlaceholder,
  frameStyleProfileNotValid,
  frameStyleTextureNotValid,
  frameStyleTextureLabel,
  frameStyleTextureDescription[] {
    ${frameBuilderPortableTextFragment}
  },
  frameStyleProfileLabel,
  frameStyleProfileDescription[] {
    ${frameBuilderPortableTextFragment}
  },
  frameStyleProfileReadMore,
  frameStyleProfileReadMoreUrl,
  frameStyleStepFooter[] {
    ${frameBuilderPortableTextFragment}
  },
`

const frameBuilderPassepartoutStringsFragment = groq`
  passepartoutStepTitle,
  passepartoutPlaceholder,
  passepartoutSizeNotValid,
  passepartoutNoPassepartoutTitle,
  passepartoutNoPassepartoutDescription,
  passepartoutColorNotValid,
  passepartoutSizeLabel,
  passepartoutWidthLabel,
  passepartoutHeightLabel,
  passepartoutStepFooter[] {
    ${frameBuilderPortableTextFragment}
  },
`

const frameBuilderGlassStringsFragment = groq`
  glassStepTitle,
  glassPlaceholder,
  glassTypeNotValid,
  glassTypeLabel,
  glassTypeDescription[] {
    ${frameBuilderPortableTextFragment}
  },
  glassStepFooter[] {
    ${frameBuilderPortableTextFragment}
  },
`

const frameBuilderSpacerStringsFragment = groq`
  spacerStepTitle,
  spacerStepPlaceholder,
  spacerSizeNotValid,
  spacerColorNotValid,
  spacerStepColorLabel,
  spacerStepFooter[] {
    ${frameBuilderPortableTextFragment}
  },
`

const frameBuilderControlsStringsFragment = groq`
  discountPercentLabel,
  controlCancelLabel,
  controlOkLabel,
  controlChooseProductHint,
  controlAddToCartHint,
  controlQuantityLabel,
  controlPriceLabel,
  chooseFileLabel,
  lengthUnitLabel,
`

export const frameBuilderStringsFragment = groq`
  ${frameBuilderArtworkSizeStringsFragment}
  ${frameBuilderArtworkPreviewStringsFragment}
  ${frameBuilderFrameStyleStringsFragment}
  ${frameBuilderPassepartoutStringsFragment}
  ${frameBuilderGlassStringsFragment}
  ${frameBuilderSpacerStringsFragment}
  ${frameBuilderControlsStringsFragment}
  frameDimensionsHeading,
  passepartoutDimensionsHeading,
  addProductError,
`

export const frameBuilderStringsObjectFragment = groq`
  "strings": *[
    _type == "frameBuilderStrings" &&
    locale == $locale
  ][0] {
    ${frameBuilderStringsFragment}
  },
`
